import React from 'react';
import SEOHead from '../components/SEOHead';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import WhyBlueSection from '../components/WhyBlueSection';
import ImageGallery from '../components/ImageGallery';
import FeaturedProductSection from '../components/FeaturedProductSection';
import ColorOptionsSection from '../components/ColorOptionsSection';
import ShippingInfoSection from '../components/ShippingInfoSection';
import TestimonialsSection from '../components/TestimonialsSection';
import AboutSection from '../components/AboutSection';
import CTASection from '../components/CTASection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
`;

const Main = styled.main`
  width: 100%;
`;

const Index = () => {
  return (
    <>
      <SEOHead />
      <PageContainer>
        <Navigation />
        <Main>
          <article itemScope itemType="https://schema.org/Article">
            <HeroSection />
            <WhyBlueSection />
            <ImageGallery />
            <FeaturedProductSection />
            <ColorOptionsSection />
            <ShippingInfoSection />
            <TestimonialsSection />
            <AboutSection />
            <CTASection />
            <FAQSection />
          </article>
        </Main>
        <Footer />
      </PageContainer>
    </>
  );
};

export default Index;
